import React from 'react'

export default function Loader2() {
  return (
 <>
 
 
 
 
 
 
 <div className='loadingforalert'>
 
 
 <img src="https://media.geeksforgeeks.org/wp-content/uploads/20200412121906/skeleton-loading.gif" alt="" />
 
 
 
</div>
 
 
 </>
  )
}
